import { TypedEventEmitter } from '@libp2p/interface';
import { UnimplementedError } from '../error.js';
export class WebRTCDirectListener extends TypedEventEmitter {
    async listen() {
        throw new UnimplementedError('WebRTCTransport.createListener');
    }
    getAddrs() {
        return [];
    }
    updateAnnounceAddrs() {
    }
    async close() {
    }
}
//# sourceMappingURL=listener.browser.js.map